import { useEffect, useRef } from "react";

// Leaflet loaded via CDN in index.html -> window.L
export default function PropertyMap({ lat, lng, exact = false, label = "", points = [] }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    const L = window.L;
    if (!L || !ref.current || mapRef.current) return;
    const map = L.map(ref.current, { scrollWheelZoom: false, attributionControl: true }).setView([lat, lng], exact ? 15 : 13);
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: "&copy; OpenStreetMap",
    }).addTo(map);

    if (exact) {
      const icon = L.divIcon({
        className: "",
        html: `<div style="background:#3E2153;width:34px;height:34px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:3px solid #00C9A7;box-shadow:0 4px 12px rgba(0,0,0,.3)"></div>`,
        iconSize: [34, 34],
        iconAnchor: [17, 34],
      });
      L.marker([lat, lng], { icon }).addTo(map).bindPopup(label || "Posizione");
    } else {
      L.circle([lat, lng], {
        radius: 700, color: "#00C9A7", fillColor: "#00C9A7", fillOpacity: 0.18, weight: 2,
      }).addTo(map).bindPopup("Zona approssimativa per privacy");
    }

    const valid = (points || []).filter((p) => typeof p.lat === "number" && typeof p.lng === "number");
    valid.forEach((p) => {
      const dot = L.divIcon({
        className: "",
        html: `<div style="background:#00C9A7;width:18px;height:18px;border-radius:50%;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35)"></div>`,
        iconSize: [18, 18], iconAnchor: [9, 9],
      });
      L.marker([p.lat, p.lng], { icon: dot }).addTo(map)
        .bindPopup(`<strong>${p.label || ""}</strong>${p.distance ? "<br>" + p.distance : ""}`);
    });
    if (valid.length) {
      const group = L.featureGroup([L.marker([lat, lng]), ...valid.map((p) => L.marker([p.lat, p.lng]))]);
      try { map.fitBounds(group.getBounds().pad(0.3)); } catch (e) {}
    }

    setTimeout(() => map.invalidateSize(), 200);
    return () => { map.remove(); mapRef.current = null; };
    // eslint-disable-next-line
  }, [lat, lng, exact, JSON.stringify(points)]);

  return <div ref={ref} data-testid="property-map" className="w-full h-72 sm:h-96 rounded-2xl overflow-hidden border border-brand-plum/10" />;
}
